var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"rich",attrs:{"dir":"auto"}},_vm._l((_vm.pieces),function(piece,index){return _c(piece.tag,{key:index,tag:"component",class:piece.class,attrs:{"dir":piece.dir,"href":piece.href,"target":piece.href ? '_blank' : null,"rel":piece.href ? 'noopener noreferrer' : null},domProps:{"textContent":_vm._s(piece.value)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }